import { Controller } from '@hotwired/stimulus';

// FIXME: jquery に依存しない構成に変更
export default class extends Controller {
  static targets = ['list', 'trigger'];

  connect() {
    if (
      this.triggerTarget.classList.contains('is-selected') ||
      this.listTarget.querySelector('.is-selected')
    ) {
      // toggle はボタンの is-selected の付け外しとリストの開閉を対にしているため、ボタンにも付ける
      this.triggerTarget.classList.add('is-selected');
      this.listTarget.style.display = 'block';
    }
  }

  // action="click->nested-menu#toggle"
  toggle({ currentTarget }) {
    currentTarget.classList.toggle('is-selected');
    $(this.listTarget).stop().slideToggle();
  }
}
